// removed by extract-text-webpack-plugin
module.exports = {"welcome":"_1WVistuQ4mgkl8iZ","logo":"_3gjwIySt1vWKuLmJ","action":"_3o5sl4MVckdW0ET1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/Welcome/Welcome.pcss
// module id = 498
// module chunks = 1